import { Injectable } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { GeographyModel } from '../models/geography';
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Injectable({
  providedIn: 'root'
})
export class GeographyProvider {

  geography: GeographyModel[] = [];
  actionSuccess:boolean = false;

  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration,
    ) {
  }

  getGeographyList(): void {
    if (this.geography.length == 0) {
      this.apiService.getHeaders(this.apiConfig.getAllGeographies).subscribe(
        (res: any) => {
          this.geography = res.body.data as GeographyModel[];
        }
      );
    }
  }

}
  // let updatedRegions =this.regions.splice(updateIndex, 1);
